<style>
    h2,
    h3,
    h4 {
        color: var(--app-brand-cyan) !important;
    }
</style>
<section class="p-5">
    <div style="color: white !important;" [innerHTML]="PolicyPrivacyText">
    </div>
</section>